module.exports = __webpack_public_path__ + "img/5.e77efc55.png";